module.exports = __webpack_public_path__ + "img/tension.3ef26d05.png";